import { request } from "../request";
const mock = "";

// 保存评价
export const saveComment = (params) =>
  request(`${mock}/v1/course/comment/save`, "POST", { json: params });
// 删除评论
export const delComment = (params) =>
  request(`${mock}/v1/course/comment/del`, "POST", { json: params });
// 获取商品评价总结
export const getCourseComment = (params) =>
  request(`${mock}/v1/course/comment/courseComment`, "GET", { params });
// 已评价列表
export const getCommentList = (params) =>
  request(`${mock}/v1/course/comment/list`, "GET", { params });
// 获取详情
export const getCommentInfo = (params) =>
  request(`${mock}/v1/course/comment/info`, "GET", { params });
//评价点赞/取消点赞
export const commentLike = (params) =>
  request(`${mock}/v1/course/comment/like`, "GET", { params });
